import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import DraftContentTable from "./DraftContentsTable";
import ConfirmationModal from "../../../Shared/ConfirmationModal";
import { draftService } from "./service/draft.service";
import { toast } from "react-toastify";

class ManageUserDraft extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      submitting: false,
      formError: null,
      data: null,
      selectedRow: null,
      hasParams: false,
      error: null,
      pageNum: 0,
      pageSize: 10,
      showModal: false,
      notResetMode: false,
      status: "DRAFT",
      showNextJoyRide: false,
    };
  }
  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getAllDrafts({ pageNum: pageNum + 1, pageSize });
    if (this.props.location.state) {
      const { run } = this.props.location.state;
      if (run) {
        this.setState({ showNextJoyRide: run });
      } else {
        return;
      }
    }
  }

  getAllDrafts = params => {
    this.setState({ fetching: true });
    draftService
      .getAllInstructorDraft(params)
      .then(response => {
        response &&
          this.setState({
            data: response,
            pages: Math.ceil(response.count / params.pageSize),
            error: null,
            fetching: false,
          });
      })
      .catch(error => this.setState({ error, fetching: false }));
  };
  discardDraft = item => {
    if (item.id) {
      draftService
        .deleteDraft(item.id)
        .then(response => {
          this.setState({ response, error: null, submitting: false });
          this.fetchData();
          toast.success("Draft deleted successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000,
          });
        })

        .catch(error => this.setState({ formError: error, submitting: false }));
    }

    this.setState({
      showModal: !this.state.showModal,
    });
  };
  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getAllDrafts(params);
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
  };

  selectRow = selectedRow => {
    this.setState({ selectedRow: selectedRow.original, hasParams: true });
  };

  showConfirmation = selectedRow => {
    this.setState({
      selectedRow: selectedRow.original,
      showModal: !this.state.showModal,
    });
  };
  //===================TOUR SECTION===================//
  routeChange = () => {
    this.props.history.push({
      pathname: `/useruploadcontents`,
      state: { run: true },
    });
  };

  setNextJoyRide = () => {
    this.setState({ showNextJoyRide: false });
  };
  render() {
    const {
      fetching,
      data,
      pages,
      pageNum,
      pageSize,
      error,
      hasParams,
      selectedRow,
      showNextJoyRide,
    } = this.state;

    return (
      <Row>
        <Col sm="12">
          <DraftContentTable
            fetching={fetching}
            hasParams={hasParams}
            selectedRow={selectedRow}
            data={data}
            selectRow={this.selectRow}
            error={error}
            showModal={this.showConfirmation}
            pages={pages}
            page={pageNum}
            pageSize={pageSize}
            filterData={this.filterData}
            setPageNumber={this.setPageNumber}
            setPageSize={this.setPageSize}
            postId={selectedRow}
            showNextJoyRide={showNextJoyRide}
            routeChange={this.routeChange}
            setNextJoyRide={this.setNextJoyRide}
          />
        </Col>
        <ConfirmationModal
          isOpen={this.state.showModal}
          showModal={this.showConfirmation}
          action={this.discardDraft}
          item={selectedRow}
          message={"Do you want to discard your draft?"}
        />
      </Row>
    );
  }
}

export default ManageUserDraft;
